import { useEffect, useState } from 'react';
import { api, isApiError } from '@/lib/api';
import { logger } from '@/lib/logger';

export interface HeroBanner {
  id: string;
  headline: string;
  subtext: string | null;
  ctaLabel: string | null;
  imageUrl: string;
  logoUrl: string | null;
  linkUrl: string;
  sortOrder: number;
  startsAt: string | null;
  endsAt: string | null;
}

export interface HeroTile {
  id: string;
  name: string;
  slug: string;
  logo: string | null;
  isNew: boolean;
}

export interface QuickOffer {
  id: string;
  name: string;
  platformKey: string;
  accountLabel: string;
  discountPct: number;
  currencies: string;
}

export interface MarketplaceHeroPayload {
  banners: HeroBanner[];
  tiles: HeroTile[];
  /** Already returned by `GET /marketplace/hero` but previously discarded. */
  quickOffers: QuickOffer[];
}

export interface MarketplaceHeroState {
  data: MarketplaceHeroPayload | null;
  loading: boolean;
}

export function useMarketplaceHero(): MarketplaceHeroState {
  const [data, setData] = useState<MarketplaceHeroPayload | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get<MarketplaceHeroPayload>('/marketplace/hero')
      .then((res) => {
        if (cancelled) return;
        if (isApiError(res)) {
          logger.warn('marketplace/hero request failed', { code: res.error.code });
        } else {
          setData(res.data);
        }
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading };
}

